// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"143":"f379a369","879":"c7dd7727"}[chunkId] + ".css";
};